import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../../config/config';

@Injectable()
export class PuntoEquilibrioService {

  dataUrl = Config.URL_BASE;

  constructor(private http: HttpClient) {
  }
  getPdf(gral_emp_id: number, tipo_periodo: number, periodo: number, anio: number) {
    let url_ = this.dataUrl + '/punto-equilibrio/reporte/pdf/' + gral_emp_id + '/' + tipo_periodo + '/' + periodo + '/' + anio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getXlsx(gral_emp_id: number, tipo_periodo: number, periodo: number, anio: number) {
    let url_ = this.dataUrl + '/punto-equilibrio/reporte/xlsx/' + gral_emp_id + '/' + tipo_periodo + '/' + periodo + '/' + anio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


    getF(gral_emp_id: number, tipo_periodo: number, periodo: number, anio: number): Observable<any> {
      let url_ = this.dataUrl + '/punto-equilibrio/get/' + gral_emp_id + '/' + tipo_periodo + '/' + periodo + '/' + anio;
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }
}
